export const removeHtmlTags = (string) => string.replace(/<[^>]*>?/gm, '');
